import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Logo RDP
import LogoRDP from "../../Assets/img/products/Logo RDP sans fond - copie.png";

// Hooks
import { useCategoriesWithProducts } from '../../hooks/useCategoriesWithProducts';

// Mapping slug -> titre pour les catégories du footer
const CATEGORY_LABELS = {
  'vin': 'Vin',
  'biere': 'Bière',
  'spiritueux': 'Spiritueux',
  'bocaux': 'Bocaux',
  'soft-drinks': 'Soft drinks',
  'huiles-sauces': 'Huiles et Sauces',
  'pet': 'PET',
  'decorees': 'Décorées'
};

const RDPFooter = () => {
  const { categories: categoriesWithProducts } = useCategoriesWithProducts();
  return (
    <footer className="bg-glass-darkest text-glass-lighter pt-[40px] pb-[20px]">
      <Container>
        {/* Section principale compacte */}
        <Row className="mb-[25px]">
          {/* Colonne 1: Logo et réseaux sociaux */}
          <Col lg={3} md={6} className="mb-[25px] md:mb-0">
            <Link to="/" className="inline-block mb-[15px]">
              <img
                src={LogoRDP}
                alt="RDP Glass Logo"
                className="h-[60px] w-auto"
              />
            </Link>
            <p className="text-glass-light text-[13px] leading-relaxed mb-[15px]">
              Spécialiste de l'emballage en verre
            </p>
            <div className="flex gap-[10px]">
              <a
                href="https://www.linkedin.com/in/thierry-dehon-77889118/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[36px] h-[36px] rounded-full bg-glass-dark hover:bg-glass-accent flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in text-white text-[14px]"></i>
              </a>
              <a
                href="mailto:thierry.dehon@rdp-glass.com"
                className="w-[36px] h-[36px] rounded-full bg-glass-dark hover:bg-glass-accent flex items-center justify-center transition-colors"
                aria-label="Email"
              >
                <i className="fas fa-envelope text-white text-[14px]"></i>
              </a>
            </div>
          </Col>

          {/* Colonne 2: Navigation */}
          <Col lg={2} md={6} className="mb-[25px] md:mb-0">
            <h6 className="text-white font-serif font-semibold mb-[15px] text-[14px]">Navigation</h6>
            <ul className="space-y-[8px]">
              <li>
                <Link to="/" className="text-glass-light hover:text-glass-accent transition-colors text-[13px]">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/produits" className="text-glass-light hover:text-glass-accent transition-colors text-[13px]">
                  Produits
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-glass-light hover:text-glass-accent transition-colors text-[13px]">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-glass-light hover:text-glass-accent transition-colors text-[13px]">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-glass-light hover:text-glass-accent transition-colors text-[13px]">
                  Contact
                </Link>
              </li>
            </ul>
          </Col>

          {/* Colonne 3: Nos produits - Liste dynamique basée sur les catégories avec produits */}
          <Col lg={3} md={6} className="mb-[25px] md:mb-0">
            <h6 className="text-white font-serif font-semibold mb-[15px] text-[14px]">Nos produits</h6>
            <ul className="space-y-[8px]">
              {categoriesWithProducts.map(slug => (
                <li key={slug}>
                  <Link
                    to={`/produits/${slug}`}
                    className="text-glass-light hover:text-glass-accent transition-colors text-[13px]"
                  >
                    {CATEGORY_LABELS[slug] || slug}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Colonne 4: Contact compact */}
          <Col lg={4} md={6} className="mb-[25px] md:mb-0">
            <h6 className="text-white font-serif font-semibold mb-[15px] text-[14px]">Contact</h6>
            <ul className="space-y-[10px]">
              <li className="flex items-start gap-[8px]">
                <i className="line-icon-Geo2-Love text-glass-accent text-[16px] mt-[2px] flex-shrink-0"></i>
                <span className="text-glass-light text-[12px] leading-snug">
                  2 Rue d'Hem, 59170 Croix, France
                </span>
              </li>
              <li className="flex items-center gap-[8px]">
                <i className="line-icon-Phone-2 text-glass-accent text-[16px] flex-shrink-0"></i>
                <a href="tel:+33680087847" className="text-glass-light hover:text-glass-accent transition-colors text-[12px]">
                  +33 6 80 08 78 47
                </a>
              </li>
              <li className="flex items-center gap-[8px]">
                <i className="line-icon-Mail text-glass-accent text-[16px] flex-shrink-0"></i>
                <a href="mailto:thierry.dehon@rdp-glass.com" className="text-glass-light hover:text-glass-accent transition-colors text-[12px] break-all">
                  thierry.dehon@rdp-glass.com
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        {/* Copyright - Une seule ligne */}
        <Row className="border-t border-glass-dark pt-[15px]">
          <Col className="text-center">
            <div className="flex flex-wrap items-center justify-center gap-x-[12px] gap-y-[8px] text-[12px] text-glass-light">
              <p className="mb-0">
                &copy; {new Date().getFullYear()} RDP Glass
              </p>
              <span className="text-glass-dark hidden md:inline">|</span>
              <Link to="/cgv" className="hover:text-glass-accent transition-colors">
                CGV
              </Link>
              <span className="text-glass-dark">|</span>
              <Link to="/mentions-legales" className="hover:text-glass-accent transition-colors">
                Mentions légales
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default RDPFooter;
